<link href="//maxcdn.bootstrapcdn.com/font-awesome/4.1.0/css/font-awesome.min.css" rel="stylesheet">
<link href="https://unpkg.com/@angular/material/prebuilt-themes/indigo-pink.css" rel="stylesheet">
<script src="assets/js/jquery-3.4.1.min.js"></script>
<script src="assets/js/multislider.js"></script>

<script>
  $('#basicSlider').multislider({
    continuous: true,
    duration: 2000
  });
  $('#mixedSlider').multislider({
    duration: 800,
    interval: 3000
  });
</script>
<script src="assets/js/popper.min.js"></script>
<script src="assets/js/all.js"></script>

<app-header *ngIf="showHead"></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
